import Client from "../../pages/client/Home"

export const DataClient = [
    {
        id : 2,
        path : "/",
        element : <Client/>
    },

]